<template>
  <div class="prakerja-merchant-detail">
    <!-- Prakerja Navbar -->
    <BlNavBarSearchMv
      :value="getKeywords"
      has-back-button
      placeholder="Cari kelas"
      class="border-bottom-gray"
      @input="handleSearch"
      @handleBackButtonClick="toPreviousPage"
    />
    <!-- End of Prakerja Navbar -->

    <BlBreadcrumbAv class="mt-12 ph-16" :breadcrumb-lists="breadcrumbItems" />

    <!-- Prakerja Merchant Header -->
    <PrakerjaMerchantHeader />
    <!-- End of Prakerja Merchant Header -->

    <BlTabsMv
      :tabs="tabs"
      :fixed-width-tabs="fixedWidthTabs"
      :active-tab-name.sync="activeTabName"
      class="merchant-tabs"
      @update:activeTabName="onTabChange"
    >
      <!-- Prakerja Tab Courses -->
      <BlTabNavMv slot="tab-nav-courses" title="Kelas tersedia" title-tag="h5" />
      <BlTabContentMv
        slot="tab-content-courses"
        v-infinite-scroll="fetchMoreCourses"
        :infinite-scroll-disabled="isAllCoursesLoaded"
        :infinite-scroll-distance="500"
      >
        <PrakerjaFilterSortTab
          data-testid="merchant-page-filter-tab"
          @leftTabClick="$router.push({name: 'merchant-search-location'})"
          @middleTabClick="$router.push({name: 'merchant-search-filter'})"
          @rightTabClick="$router.push({name: 'merchant-search-sort'})"
        />
        <PrakerjaMerchantCourses />
      </BlTabContentMv>
      <!-- End of Prakerja Tab Courses -->

      <!-- Prakerja Tab How to Redeem -->
      <BlTabNavMv slot="tab-nav-redeem" title="Cara redeem voucher" title-tag="h5" />
      <BlTabContentMv slot="tab-content-redeem">
        <BlFlexContainerMv direction="column" padding="16px" class="sanitize-text">
          <div v-html="infoRedeem"></div>
        </BlFlexContainerMv>
      </BlTabContentMv>
      <!-- End of Prakerja Tab How to Redeem -->

      <!-- Prakerja Tab Profile -->
      <BlTabNavMv slot="tab-nav-profile" :title="`Profil Lembaga ${merchantDetail.name}`" title-tag="h5" />
      <BlTabContentMv slot="tab-content-profile">
        <PrakerjaMerchantProfile class="sanitize-text" />
      </BlTabContentMv>
      <!-- End of Prakerja Profile -->
    </BlTabsMv>

    <router-view />

    <BlSeparatorAv :height="12" />

    <PrakerjaMerchantAbout />
  </div>
</template>

<script>
import PrakerjaFilterSortTab from '../components/PrakerjaSearchPage/PrakerjaFilterSortTab.vue';
import {mapGetters} from 'vuex';
import infiniteScroll from 'vue-infinite-scroll';
import {generateURLString} from 'shared_js/coupon-deals';

import sanitizeHtml from 'sanitize-html';
import {BlNavBarSearchMv, BlTabsMv, BlTabContentMv, BlSeparatorAv} from '@bukalapak/bazaar-mweb-latest';
import BlTabNavMv from 'shared/components/BLTabNavMv';
import BlBreadcrumbAv from 'shared/components/BlBreadcrumbAv';

import PrakerjaMerchantHeader from '../components/PrakerjaMerchantPage/PrakerjaMerchantHeader';
import PrakerjaMerchantCourses from '../components/PrakerjaMerchantPage/PrakerjaMerchantCourses';
import PrakerjaMerchantProfile from '../components/PrakerjaMerchantPage/PrakerjaMerchantProfile';
import PrakerjaMerchantAbout from '../components/PrakerjaMerchantPage/PrakerjaMerchantAbout';
import trackerGenerator from '../mixins/tracker-generator';
import {TRACKER_EVENT_VP_PRAKERJA_MERCHANT_COURSES} from '../config/tracker-events';

export default {
  name: 'PrakerjaMerchantDetailPage',
  directives: {infiniteScroll},
  components: {
    BlNavBarSearchMv,
    BlTabsMv,
    BlTabNavMv,
    BlTabContentMv,
    PrakerjaMerchantHeader,
    PrakerjaMerchantCourses,
    PrakerjaMerchantProfile,
    PrakerjaFilterSortTab,
    BlSeparatorAv,
    PrakerjaMerchantAbout,
    BlBreadcrumbAv,
  },
  mixins: [trackerGenerator],
  data() {
    return {
      activeTabName: 'courses',
      tabs: ['courses', 'redeem', 'profile'],
      fixedWidthTabs: ['courses', 'redeem', 'profile'],
      scrollLeft: 0,
    };
  },
  computed: {
    ...mapGetters(['getPreviousPage']),
    ...mapGetters('courses', ['getKeywords']),
    ...mapGetters({
      merchantDetail: 'merchants/getMerchantDetail',
      merchantCourses: 'courses/getCourses',
      isAllCoursesLoaded: 'courses/getIsAllCoursesLoaded',
    }),
    merchantId() {
      let id = this.$route.params.id;
      if (!this.isOldURL) {
        const URL = this.$route.params.id.split('-');
        id = Number.parseInt(URL.pop(), 10);
      }
      return id;
    },
    infoRedeem() {
      return sanitizeHtml(this.merchantDetail.redemption_info);
    },
    isFromDetailPage() {
      return this.getPreviousPage.name === 'detail';
    },
    isOldURL() {
      return Number.isInteger(parseInt(this.$route.params.id));
    },
    breadcrumbItems() {
      return [
        {
          name: 'Beranda',
          url: process.env.BASE_PATH,
        },
        {
          name: this.merchantDetail.name,
          url: '#',
        },
      ];
    },
  },
  mounted() {
    this.initMerchantDetail();
  },
  methods: {
    handleSearch(value) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = null;
      }

      this.searchTimeout = setTimeout(() => {
        const lowercasedKeyword = value.toLowerCase();

        this.activeTabName = 'courses';
        this.$store.commit('courses/resetCourses');
        this.$store.commit('courses/setCoursesFilter', {keywords: lowercasedKeyword});
        this.$store.dispatch('courses/fetchCourses');

        window.scrollTo({top: 0, behavior: 'smooth'});
      }, 500);
    },
    async initMerchantDetail() {
      this.$store.commit('resetErrors');
      this.$store.commit('merchants/resetMerchantDetail');
      this.$store.commit('categories/setSelectedCategory', 'all');

      if (!this.isFromDetailPage) {
        // from landing page or any page other than prakerja detail page
        // it starts FRESH
        // reset courses, fetch new courses with filter by merchant id
        window.scrollTo(0, 0);
        this.$store.commit('courses/resetCourses');
        this.fetchCourses();
      } else {
        // from prakerja detail page
        // don't reset filter, only refetch courses
        this.fetchMoreCourses();
      }
      await this.$store.dispatch('merchants/fetchMerchantDetail', this.merchantId);
      await this.$store.dispatch('merchants/fetchMerchants');
      await this.$store.dispatch('merchants/fetchHighlightedMerchant');
      if (this.isOldURL) {
        this.$router.replace({
          name: 'merchant',
          params: {id: generateURLString(`${this.merchantDetail.name} ${this.merchantId}`)},
          query: {...this.$route.query, referrer: this.$route.query.referrer},
        });
      }
      this.trackPrakerjaMerchant();
    },
    trackPrakerjaMerchant() {
      const payload = {
        session_id: this.$root.mixinSessionId,
        source: this.$route.query.source,
      };
      this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_MERCHANT_COURSES, payload);
    },
    fetchMoreCourses() {
      this.$store.dispatch('courses/fetchCourses');
    },
    fetchCourses() {
      this.$store.commit('courses/resetCoursesFilter');
      this.$store.commit('courses/setCoursesFilter', {merchants: [this.merchantId]});
      this.fetchMoreCourses();
    },
    toPreviousPage() {
      if (this.getPreviousPage?.name) this.$router.go(-1);
      else this.$router.push({name: 'landing', query: this.$route.query});
    },
    onTabChange(val) {
      const tabNav = document.getElementsByClassName('bl-tab__nav')[0];
      if (val === 'profile') {
        tabNav.scrollLeft = tabNav.scrollWidth;
      } else if (val === 'courses') {
        tabNav.scrollLeft = 0;
      }
      this.scrollLeft = tabNav.scrollLeft;
    },
  },
};
</script>

<style lang="scss" scoped>
.merchant-tabs {
  border-top: 1px solid #ebebeb;
  &::v-deep .bl-tab__nav {
    overflow-x: scroll !important;
  }
}
</style>
